export default {
  name: 'ClientMaterialGroupSettingExpand',
  props: {
    loading: Boolean,
    data: Object
  },
  computed: {
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    },
    tableHeaders () {
      const headers = [];
      headers.push({ key: 'material_group_id', label: this.$t('material-group.title'), format: 'formatFromConfig', configKey: 'material_groups', configParam: 'name' });
      headers.push({ key: 'reportSubcode', label: this.$t('report.title'), format: 'formatFunc', funcs: [this.getReportName], classFuncs: [] });
      headers.push({ key: 'from_date_period_id', label: this.$t('general.filters.date-period-from'), format: 'formatDatePeriod' });
      headers.push({ key: 'to_date_period_id', label: this.$t('general.filters.date-period-to'), format: 'formatDatePeriod' });
      headers.push({ key: 'value', label: this.$t('material-group.discount'), format: 'formatPercent' });
      if (this.canEdit) {
        const actions = [
          { label: this.$t('menu.clients.materialgroupsetting.edit'), emit: 'editItem', icon: 'edit', bion: 'pencil', ifconfig: { param: 'id', value: null, notCheck: true } },
          { label: this.$t('menu.clients.materialgroupsetting.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash', ifconfig: { param: 'id', value: null, notCheck: true } }
        ];
        headers.push({ key: 'actions', label: '', actions: actions });
      }
      return headers;
    },
    reportOptions () {
      return this.ZPFormatHelper.getReportNameOptions(false, false);
    }
  },
  methods: {
    getReportName (val) {
      const el = this.reportOptions.find(el => el.reportSubcode == val);
      if (el) {
        return el.text;
      }
      return '';
    }
  }
}
